export default function WhyCareInsure() {
  return (
    <section id="why-careinsure" className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-[#E8F4F8] via-white to-[#F0F8FF] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #4A90E2 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="inline-block px-4 py-2 bg-[#4A90E2]/10 text-[#4A90E2] text-xs sm:text-sm font-semibold rounded-full mb-4 md:mb-6">
            WHY CAREINSURE
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-4">
            왜 케어인슈인가?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 px-4">
            장기요양기관의 실질적인 어려움을 이해하고<br className="hidden sm:block" />
            합리적인 해결책을 제시합니다
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 px-4 sm:px-0">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 group">
            <div className="relative mb-6">
              <div className="w-full h-40 md:h-48 bg-gradient-to-br from-[#4A90E2]/10 to-[#E8F4F8] rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/5c8d5c55bc4436309159aea500bbec02.jpg"
                  alt="경험 요율 설계"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-14 h-14 md:w-16 md:h-16 bg-[#4A90E2] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-price-tag-3-line text-xl md:text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 text-center">경험 요율 기반</h3>
            <p className="text-sm md:text-base text-gray-600 text-center leading-relaxed">
              20년간 축적된 자사 경험<br />데이터로 설계된<br />합리적인 보험료 구조
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 group">
            <div className="relative mb-6">
              <div className="w-full h-40 md:h-48 bg-gradient-to-br from-[#4A90E2]/10 to-[#E8F4F8] rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20Korean%20insurance%20contract%20renewal%20document%20with%20continuous%20coverage%20guarantee%20stamp%20and%20official%20paperwork%20in%20modern%20office%20setting%20with%20blue%20professional%20theme%20with%20Korean%20people&width=400&height=400&seq=why-card-korean-002&orientation=squarish"
                  alt="재가입 보장"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-14 h-14 md:w-16 md:h-16 bg-[#4A90E2] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-refresh-line text-xl md:text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 text-center">재가입 보장</h3>
            <p className="text-sm md:text-base text-gray-600 text-center leading-relaxed">
              사고 발생 시에도<br />합리적 할증으로<br />계속 가입 가능
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 group">
            <div className="relative mb-6">
              <div className="w-full h-40 md:h-48 bg-gradient-to-br from-[#4A90E2]/10 to-[#E8F4F8] rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20Korean%20claims%20adjuster%20analyzing%20accident%20report%20with%20clear%20responsibility%20division%20documents%20in%20modern%20office%20with%20organized%20workspace%20and%20blue%20accents%20with%20Korean%20people&width=400&height=400&seq=why-card-korean-003&orientation=squarish"
                  alt="명확한 책임 구분"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-14 h-14 md:w-16 md:h-16 bg-[#4A90E2] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-scales-3-line text-xl md:text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 text-center">명확한 책임 구분</h3>
            <p className="text-sm md:text-base text-gray-600 text-center leading-relaxed">
              전담 손해사정사의<br />정확한 사고 분석과<br />책임 판단
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 group">
            <div className="relative mb-6">
              <div className="w-full h-40 md:h-48 bg-gradient-to-br from-[#4A90E2]/10 to-[#E8F4F8] rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Korean%20business%20professionals%20team%20providing%20evaluation%20and%20operational%20support%20services%20in%20modern%20office%20environment%20showing%20collaboration%20and%20teamwork%20with%20Asian%20Korean%20people%20working%20together%20professionally%20with%20supportive%20atmosphere%20and%20blue%20color%20scheme%20featuring%20Korean%20ethnicity%20individuals&width=400&height=400&seq=why-card-korean-team-support-010&orientation=squarish"
                  alt="평가·운영 지원"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-14 h-14 md:w-16 md:h-16 bg-[#4A90E2] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-team-line text-xl md:text-2xl text-white"></i>
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 text-center">평가·운영 지원</h3>
            <p className="text-sm md:text-base text-gray-600 text-center leading-relaxed">
              평가 대비부터<br />일상 운영까지<br />전방위 지원 시스템
            </p>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 md:mt-16 lg:mt-20 text-center px-4 sm:px-0">
          <div className="inline-block bg-white rounded-2xl md:rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 w-full max-w-4xl">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              지금 바로 케어인슈의 차별화된 서비스를 경험하세요
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-6 md:mb-8">
              전문 컨설턴트가 시설에 맞는 최적의 솔루션을 제안해 드립니다
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('consultation');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                }
              }}
              className="px-8 md:px-10 py-3 md:py-4 bg-[#4A90E2] text-white text-sm md:text-base font-semibold rounded-xl hover:bg-[#357ABD] transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              무료 상담 신청하기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
